export let words: any = {
  //login screen
  login_to_continue: "Login to Continue",
  login: "Login",
  your_email: "Your Email",
  Password: "password",
  or: "OR",
  login_with_number: "Login with number",
  login_with_apple: "Login with Apple",
  login_with_google: "Login with Google",
  dont_have_a_account: "Don’t have an account?",
  forget_password: "Forget Password",
  register: "Register",
  skip_for_now: "Skip For Now",
  invalidEmailAddress: "Invalid email address",
  emailIsRequired: "Email is required",
  passwordIsRequired: "Password is required",
  conPasswordIsRequired: "Password is required",
  fullIsRequired: "Full name is required",
  lastIsRequired: "Last name is required",
  contactIsRequired: "Contact is required",
  forgot_password_with_mark: "Forgot Password?",
  enter_your_email_to_reset:
    "Enter your email address and we'll send you reset password link to your email address",
  send_link: "Send Link",

  //mobile number screen
  back: "Back",
  enter_mobile_number: "Enter Mobile Number",
  mobile_number: "Mobile Number",
  by_continuing_you_agree: "By continuing, you agree to our Terms & Conditions",
  continue: "Continue",

  //otp screen
  please_enter_otp: "Please enter 4 digit OTP code sent to",
  didnt_receive_otp: "Didn’t receive the OTP?",
  resend: "Resend",
  otp_verification: "Otp Verification",
  confirm: "Confirm",

  //register screen
  full_name: "Full Name",
  last_name: "Last Name",
  first_name: "First Name",
  contact_number: "Contact Number",
  email: "Email",
  password: "Password",
  password_again: "Confirm Password",
  i_have_read_term: "I Have Read And Acknowledged All",
  terms_and_policies: "Terms And Policies",
  already_have_acc: "Already Have an Account",
  sign_in: "Sign in",
  sign_up: "Sign Up",

  //home screen
  al_baqarah: "Al-Baqarah",
  juz_1: "Juz'1",
  nov_1_vers: "Nov 1 . Verse 7 , Makkiyah",
  bookmark: "Bookmark",
  bookmarks: "Bookmarks",
  index: "Indexs",
  notes: "Notes",
  Baqarah: "Al-Baqarah 8",
  Seen: "Just Now",
  remove: "Remove",
  Enter: "Enter Text",
  Save: "Save Settings",
  ayat: "مرحبا أنا معظم هنا مرحبا أنا معظم هنا مرحبا",
  addNote: "Add a note",
  fetchData: "Fetch Al-Quran Data",
  popular_qari: "Popular Qari",
  evening_azkar: "Evening Azkar",
  morning_azkar: "Morning Azkar",
  afternoon_azkar: "Good Afternoon",
  azkar: "Azkar",

  // sidebar
  juz1: "Juz' 1",
  juz2: "Juz' 2",
  juz3: "Juz' 3",
  edit_profile: "Edit Profile",
  logout: "Logout",
  quick_setting: "Quick Setting",
  language: "Language",
  english: "English",
  arabic: "Arabic",
  font_size: "Font Size",
  al_fatihah: "Al-Fatihah",
  search_: "Search...",
  notFound: "Not Found",
  searchText: "Search First",
  theme: "Theme",
  light: "Light",
  dark: "Dark",
  juz: "Juz",
  surahs: "Surahs",
  font_preference: "Font Preference",
  send_feedback: "Send Feedback",

  //toast messages
  userNotFount: "User Not Found",
  numberNotFount: "Number Not Found",
  numberRequired: "Number Feild Required",
  noteRequired: "Note Feild Required",
  numberOrEmail: "Number or Email Already Exist",
  someThing: "Something Went Wrong",
  otpVerficationReq: "OTP required for verification",
  verificationFail: "Verification failed",
  loginFirst: "Need Login To Continue",
  alert: "Alert",
  loginRequire: "You must be logged in to access this feature.",
  alreadyBook: "Already Bookmarked",
  alreadySaved: "Already Saved",
  bookSave: "Bookmarked Saved",
  notsSave: "Notes Saved",
  notsReq: "Notes Required",
  otpNotMatch: "Otp Is Note Matched",
  not_connect: "Internet Not Connected",
  not_connect_req: "Internet Connection Is Required",
  profile_updated: "Profile Updated Successfully",
  login_success: "Login Successfully",
  resgister_success: "Login Successfully",

  //search
  search_qari: "Search Qari",
  type_here: "Type Here",

  // tabs
  home: "Home",
  search: "Search",
  radio: "Radio",
  settings: "Settings",
  downloaded: "Downloaded",

  // radio
  now_listing: "Now Listing",
  popular_radio: "Popular Radio",
  al_quran_radio: "Al Quran Radio",

  //verse screen
  madaniyah: "Madaniyah",
  makkiyah: "Makkiyah",
  verse: "Verse",
  no: "No",

  // notes
  font_size_note:
    "Change willl appear in : Notifications, Tarsier, Translations and information Cards.",
  save: "Save",
  cancel: "Cancel",
  skip: "Skip For Now",
  empty_data: "Data is Empty",
  al_quran_audio: "Al Quran Audio Website",
  al_quran_pro: "Al Quran Al Kareem Website",
  not_select: "Not Selected",
};
